export const HOME = "route/home";
export const CART = "route/cart";